module.exports = __webpack_public_path__ + "static/media/pulverizador.d0c3e742.svg";